export default {
  setIsShowLocation(value) {
    return axios
      .put('/profile/settings/set-is-show-location', {is_show_location: value})
      .then(response => response.data);
  },
};
